"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFiltersContainer = exports.HiddenFilterLabel = exports.FilterLabel = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const styles_1 = require("../../styles");
exports.FilterLabel = (0, styled_1.default)('label') `
  display: block;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  -webkit-font-smoothing: antialiased;
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0 ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.HiddenFilterLabel = styles_1.VisuallyHidden.withComponent('label');
exports.StyledFiltersContainer = (0, styled_1.default)('div') `
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  & > *:not(:last-of-type) {
    margin-right: 0.5em;
  }
`;
//# sourceMappingURL=styles.js.map